import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export default function RetreatImageUploadInfo() {
  const { t } = useTranslation();

  return (
    <OverlayTrigger
      placement="top"
      delay={{ show: 250, hide: 100 }}
      trigger={["hover", "focus"]}
      overlay={
        <Tooltip
          id="retreat-image-upload-info-tooltip"
          className="retreat-image-upload-tooltip"
        >
          <div className="text-start" style={{ maxWidth: "300px" }}>
            <div className="mb-2">
              {t("retreat_image_upload_tooltip_size")}
            </div>

            <ul className="mb-2 ps-3">
              <li>{t("retreat_image_upload_tooltip_landscape")}</li>
              <li>{t("retreat_image_upload_tooltip_portrait")}</li>
              <li>{t("retreat_image_upload_tooltip_square")}</li>
            </ul>

            <div>{t("retreat_image_upload_tooltip_file_size")}</div>
            <div>{t("retreat_image_upload_tooltip_formats")}</div>
          </div>
        </Tooltip>
      }
    >
      <span
        className="ms-2 align-middle d-inline-flex"
        style={{ cursor: "help" }}
        tabIndex={0}
        role="button"
        aria-label={t("retreat_image_upload_tooltip_aria")}
      >
        <i className="mdi mdi-information-outline text-primary fs-5" />
      </span>
    </OverlayTrigger>
  );
}